import React from 'react';

import ContentWithBackButton from 'components/PageLayout/ContentWithBackButton';

import styles from './PoliciesPage.module.scss';

const GeneralContent = () => {
  const renderContent = () => {
    return (
      <ContentWithBackButton title='Disclosures'>
        <div className={styles.formContent}>
          <p>
            <span>Loan Solicitations or Advertisement:</span> Lending decisions subject to application, eligibility, credit check, underwriting and approval. Not all applicants will qualify. Available loan amounts, interest rates, repayment terms and other loan terms may vary by state and are subject to change due to market conditions and/or consumer eligibility. Lending decisions and funding times subject to system limitations. Some applications may require additional verification, which can delay the lending decision. Active service members, their dependents and persons in bankruptcy may not be eligible for this loan program. Certain additional terms, limitations and conditions apply. Loan services in Georgia are offered through Covington Credit of Georgia, inc., NMLS ID# 2029624. Contact your local office with any questions.
          </p>
          <p>
            <span>GA, MO, AL, TX and TN Customers:</span> A non-refundable $2.95 transaction fee will be applied to all debit card payments made over the phone or online.
          </p>
          <p>
            <span>OK Customers Only:</span> A $2.95 transaction fee will be applied to all debit card payments over $75.00.
          </p>
        </div>
      </ContentWithBackButton>
    );
  };

  return renderContent();
};

export default GeneralContent;
